import SevenStoriesView from './SevenStoriesView'
export default SevenStoriesView
